import { useFieldArray, useFormContext } from "react-hook-form";
import { NumericControl } from "../../../../../_components/Forms/NumericControl";
import { CardView } from "../../../../../_components/Abstractions/CardView";
import { HorizontalView } from "../../../../../_components/Abstractions/HorizontalView";
import { WastesSelect } from "../WastesSelect";
import { DomainSwitch } from "../../../../../_components/Abstractions/DomainSwitch";
import { FormControl } from "../../../../../_components/Forms/FormControl";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export function WastesRatePlanForm() {
  const { fields, replace } = useFieldArray({ name: "wastes" });
  const { resetField, watch, getFieldState, getValues } = useFormContext();
  const fieldState = getFieldState("wastes");
  const { contractorWastes } = useSelector((x) => x.contractors);
  const usedWastes = getValues("usedWastes");
  const isUpdate = getValues("isUpdate");
  const isClone = getValues("isClone");
  const type = watch("type");
  const addressId = watch("addressId");
  const addressesIds = watch("addressesIds");
  const multipleRatePlans = watch("multipleRatePlans");
  const [isCurrentAddressEmpty, setIsCurrentAddressEmpty] = useState(true);
  const [currentType, setCurrentType] = useState(null);


  useEffect(() => {
    const isNewAddressEmpty = isAddressEmpty(addressId);

    if(isUpdate || isClone || ((isNewAddressEmpty && isCurrentAddressEmpty) && currentType === type) || multipleRatePlans) {
      return;
    }

    setCurrentType(type);
    setIsCurrentAddressEmpty(isNewAddressEmpty)
    if(isNewAddressEmpty) {
      if (!contractorWastes || contractorWastes.loading) {
        return;
      }

      // const usedWastesIdsWithoutKinds = Object.entries(usedWastes)
      // .filter(x => !x.wasteKindId)
      // .map([addressId, wastes] => wastes) TODO implement in future
      const wastesForRatePlan = groupByWasteKindForContractor(contractorWastes, type);
      replace(wastesForRatePlan);
      return;
    }

    const usedWastesForAddress = usedWastes[addressId];
    const wastesForRatePlan = groupByWasteKind(usedWastesForAddress, type);
    replace(wastesForRatePlan);
  }, [type, addressId]);

  useEffect(() => {
    if (!multipleRatePlans) {
      return;
    }

    if(!!addressId) {
      resetField("addressId");
    }

    const wastesForRatePlan = groupByWasteKindForAddresses(addressesIds, usedWastes);
    replace(wastesForRatePlan);

  }, [multipleRatePlans, addressesIds]);

  const isAddressEmpty = (address) => !address || address === "";

  return <>
    <CardView headerText="Towary" headerTypo="h5">
      <div className="domain-control error mb-2">{fieldState?.error?.message}</div>
      {fields?.length === 0 && <i>Brak towarów dla danego adresu / kontrahenta</i>}
      {fields?.map((waste, index) => (
        <WasteRatePlanForm key={waste.id} index={index}/>
      ))}
    </CardView>
  </>;
}

const WasteRatePlanForm = ({ index }) => {
  const GetFieldName = (fieldName, index) => `wastes[${index}].${fieldName}`;
  const { watch } = useFormContext();
  const isAdvancedPricing = watch(GetFieldName("isAdvancedPricing", index))

  return <>
    <HorizontalView columnsSize={[7, 3, 2]}>
      <WastesSelect name={GetFieldName("waste", index)} label="Towar" skipInitLoading readonly/>
      <FormControl name={GetFieldName("wasteKindName", index)} label="Gatunek" readonly required={false} />
      {!isAdvancedPricing && <NumericControl name={GetFieldName("price", index)} label="Cena" required={false}/>}
    </HorizontalView>
    <DomainSwitch name={GetFieldName("isAdvancedPricing", index)} label="Zaawansowany cennik"></DomainSwitch>
    <HorizontalView columnsSize={[3, 3, 3]}>
      {isAdvancedPricing && <NumericControl name={GetFieldName("priceBaled", index)} label="Cena bel." required={false}/>}
      {isAdvancedPricing && <NumericControl name={GetFieldName("priceLoose", index)} label="Cena luz" required={false}/>}
    </HorizontalView>
  </>
}

const groupByWasteKind = (data, type) => {
  const results = [];
  data.forEach(entry => {
    if (!entry.transactionTypes?.includes(type)) {
      return;
    }

    entry.wasteKinds.forEach(x => {
      results.push({
        wasteKind: x,
        wasteKindName: x.name,
        waste: entry.waste
      });
    });

    if(entry.wasteKinds.length === 0) {
      results.push({
        wasteKind: null,
        wasteKindName: null,
        waste: entry.waste
      });
    }
  });

  return results;
};

const groupByWasteKindForContractor = (data, type) => {
  const results = [];

  data.forEach(waste => {
    if (!waste.transactionTypes?.includes(type)) {
      return;
    }

    waste.kinds?.forEach(x => {
      results.push({
        wasteKind: x,
        wasteKindName: x.name,
        waste: waste
      });
    });

    if(!waste.kinds || waste.kinds?.length === 0) {
      results.push({
        wasteKind: null,
        wasteKindName: null,
        waste: waste
      });
    }
  });
  return results;
};

const groupByWasteKindForAddresses = (addressesIds, usedWastesForAddresses) => {
  const results = [];
  const seen = new Set(); // Set to track unique combinations
  addressesIds?.forEach(addressId => {
    const wastes = usedWastesForAddresses[addressId] || [];

    wastes.forEach(entry => {
      const { waste, wasteKinds } = entry;
      const wasteId = waste.wasteId;
      if (wasteKinds?.length > 0) {
        wasteKinds.forEach(kind => {
          const key = `${wasteId}_${kind.wasteKindId}`;
          if (!seen.has(key)) {
            seen.add(key);
            results.push({
              wasteKind: kind,
              wasteKindName: kind.name,
              waste: waste
            });
          }
        });
      } else {
        const key = `${wasteId}_null`;
        if (!seen.has(key)) {
          seen.add(key);
          results.push({
            wasteKind: null,
            wasteKindName: null,
            waste: waste
          });
        }
      }
    });
  });

  return results;
};
